<template>
    <main class="main">

        <section class="delivery-sec">

            <div class="container">
                <div class="delivery-sec__banner">
                    <picture>
                        <source srcset="https://batnorton.com/img/delivery-baner.webp" type="image/webp">
                        <img class="img-element" src="https://batnorton.com/img/delivery-baner.jpg" alt="">
                    </picture>
                </div>
                <Aside :page="componentName"/>

                <component :is="componentName" />
            </div>
        </section>

    </main>
</template>

<script>
import Aside from './aside-bar-public.vue'
import Delivery from './delivery.vue'
import PublicOffer from './public-offer.vue'
import Payment from './payment.vue'
import Refund from './refund.vue'
import PrivacyPolicy from './privacy-policy.vue'
import Forbuyers from './forbuyers.vue'
import Sizes from './sizes.vue'
export default {
    props:{
        page:String
    },
    components:{
        Aside,Delivery,PublicOffer,Payment,Refund,PrivacyPolicy,Forbuyers,Sizes
    },
    mounted() {

    },
    computed: {
        componentName () {
            return this.page
        },
    },
    name: "index"
}
</script>

<style scoped>

</style>
